module.exports = __webpack_public_path__ + "img/join_content_1.dbf803fd.png";